// Token configuration
// Uses environment variables with fallbacks for development

// Shopify App Bridge API key - injected at build time via Vite
// Note: Client ID is public (not a secret) - it's visible in the browser anyway
// Set VITE_SHOPIFY_CLIENT_ID in .env or as a build arg
export const shopifyClientId = import.meta.env.VITE_SHOPIFY_CLIENT_ID || ''

// Google Drive Picker credentials - injected at build time via Vite
// Set VITE_GOOGLE_DRIVE_CLIENT_ID and VITE_GOOGLE_DRIVE_DEVELOPER_KEY in .env or as build args
export const googleClientId = import.meta.env.VITE_GOOGLE_DRIVE_CLIENT_ID || ''

export const googlePickerDeveloperToken = import.meta.env.VITE_GOOGLE_DRIVE_DEVELOPER_KEY || ''

// Google Cloud Project Number (NOT the alphanumeric project ID, and NOT the
// OAuth client ID) — required by the Picker so that drive.file-scoped grants
// propagate to API calls made with our OAuth client's token. Without it the
// picker grants access but our token still 404s when reading the file.
export const googleDriveAppId = import.meta.env.VITE_GOOGLE_DRIVE_APP_ID || ''

export const stripeToken = process.env.STRIPE_PUBLISHABLE_KEY || ''
